import { render, staticRenderFns } from "./material-item.vue?vue&type=template&id=0200667e"
import script from "./material-item.vue?vue&type=script&lang=js"
export * from "./material-item.vue?vue&type=script&lang=js"
import style0 from "./material-item.vue?vue&type=style&index=0&id=0200667e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports